import { apiRequest } from './api';

/**
 * Get document sections for a specific document
 * @param documentId The ID of the document
 * @returns Promise containing document sections data
 */
export const getDocumentSections = async (
  documentId: string,
): Promise<{
  documentName: string;
  hasEmbeddings: boolean;
  sections: Array<{
    idx: number;
    header: string | null;
    characterCount: number;
  }>;
}> => {
  return apiRequest(`/admin/summary-test/document-sections/${documentId}`);
};
